import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SignaturePad from "react-signature-canvas";

export default function SignatureForm({ formData, setFormData }) {
  const { t } = useTranslation();
  const sigPad = useRef(null);
  const [isSaved, setIsSaved] = useState(false);

  const saveSignature = async () => {
    const dataUrl = sigPad.current.getTrimmedCanvas().toDataURL("image/png"); // ✅ Fixed

    setFormData({
      ...formData,
      signature: dataUrl,
    });
    setIsSaved(true);
    sigPad.current.off();
  };

  const clearSignature = () => {
    setFormData({
      ...formData,
      signature: null,
    });
    setIsSaved(false);
    sigPad.current.clear();
    sigPad.current.on();
  };

  useEffect(() => {
    // ✅ Correct way to get the canvas element:
    const canvas = sigPad.current.getTrimmedCanvas();
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;

    // Set actual drawing buffer size
    canvas.width = width * ratio;
    canvas.height = height * ratio;

    // Scale context to avoid blur
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);

    sigPad.current.clear();
  }, []);

  return (
    <div className="signature-cont">
      <SignaturePad ref={sigPad} canvasProps={{ className: "sigCanvas" }} />
      <div className="full-cont">
        <button
          type="button"
          className={
            isSaved ? "faded-success-btn all-btn" : "purple-btn all-btn"
          }
          onClick={saveSignature}
        >
          {t("buttons.save-signature")}
        </button>
        <button
          type="button"
          className="cancel-btn all-btn"
          onClick={clearSignature}
        >
          {t("buttons.clear")}
        </button>
      </div>
    </div>
  );
}
